<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《自动续费服务协议》</p>
            <div class="wenzi_zhenduo">
一、协议概述

<br/>本自动续费服务协议（以下简称 “本协议”）是您（以下简称 “用户”）与 [服务提供方名称]（以下简称 “我们” 或 “服务方”）之间就您使用我们提供的自动续费服务所达成的协议。本协议旨在明确双方在自动续费服务中的权利和义务，以确保服务的顺利提供和使用。

<br/><br/>二、自动续费服务的定义和范围

<br/>1.自动续费服务是指用户在使用我们提供的某项服务（以下简称 “基础服务”）时，授权服务方通过用户指定的支付方式，在服务的订阅周期到期时自动扣除相应费用，以延续该服务的使用期限，而无需用户手动操作的服务。
<br/>2.自动续费服务仅适用于基础服务的续费，具体包括但不限于 [列出具体服务名称，如会员服务、订阅服务等]。用户通过开启自动续费服务，将能持续享受基础服务所带来的各项权益，而无需担心因忘记续费而导致服务中断。

<br/><br/>三、服务的开通和使用

<br/>1.用户在使用基础服务时，可根据自身需求选择是否开启自动续费服务。用户开启自动续费服务的操作将视为用户对本协议的同意和接受，并授权服务方在用户的服务订阅周期到期时，从用户指定的支付账户中扣除相应的费用。
<br/>2.为使用自动续费服务，用户需要确保其提供的支付账户信息（包括但不限于账户名称、支付账号、支付密码等）准确、完整且有效。用户应对因支付账户信息错误或变更而导致的自动续费失败或其他问题自行承担责任。
<br/>3.服务方有权根据用户的使用记录和支付信息，为用户提供相应的自动续费服务，并在服务即将到期时自动完成续费操作。用户应保证其支付账户有足够的余额或支付能力，以支付相应的服务费用。

<br/><br/>四、服务费用及支付

<br/>1.自动续费服务的费用将根据用户所订阅的基础服务的类型和时长而定，具体费用将在用户选择基础服务时显示，并在服务方的官方网站或应用程序界面上明确公布。服务方有权根据运营成本、市场情况等因素对费用进行调整，但会提前通知用户。
<br/>2.服务方将通过用户指定的支付方式进行费用的扣除，具体的支付方式包括但不限于 [列出支持的支付方式，如微信支付、支付宝支付、银行卡支付等]。用户应确保所使用的支付方式的合法性和有效性，并遵守相应支付机构的规定。
<br/>3.在进行自动续费操作时，用户将收到来自支付机构的支付确认信息，包括支付金额、服务期限等内容。用户若对支付信息有异议，应及时联系服务方或支付机构进行核实和处理。

<br/><br/>五、服务期限和自动续费周期

<br/>1.自动续费服务的服务期限将根据用户所订阅的基础服务的订阅周期而定，例如，若用户订阅的基础服务为月度服务，则自动续费服务的周期为一个月；若为年度服务，则周期为一年。
<br/>2.服务方将在用户的基础服务订阅周期即将到期时，按照用户选择的自动续费服务进行费用扣除和服务期限的延长操作。用户可在服务方的账户设置页面查看自己的服务到期时间和自动续费状态。

<br/><br/>六、用户的权利和义务

<br/>1.用户有权在任何时候终止自动续费服务，具体操作可通过服务方的账户设置页面或联系客服人员进行。用户应在自动续费操作发生前完成终止操作，以避免费用的扣除。
<br/>2.用户有权知悉自动续费服务的费用、服务期限、服务内容等信息，并可要求服务方提供相关信息的查询和解释服务。
<br/>3.用户应遵守本协议及相关法律法规，不得利用自动续费服务从事任何违法违规或损害服务方或其他用户利益的行为。
<br/>4.用户应妥善保管自己的账户信息和支付信息，避免因信息泄露导致的风险和损失。如因用户的疏忽导致账户信息泄露或其他用户行为引发的问题，用户自行承担责任。

<br/><br/>七、服务方的权利和义务

<br/>1.服务方有权根据自身的业务需要和相关法律法规，对自动续费服务进行调整、更新或终止，但应提前通知用户。
<br/>2.服务方有义务保障自动续费服务的正常运行，确保在用户服务订阅周期到期时能够及时、准确地完成自动续费操作，但因不可抗力、用户支付账户问题、网络故障等因素导致的自动续费失败除外。
<br/>3.服务方应在用户开启自动续费服务时，向用户明确告知服务的费用、服务期限、服务内容及其他重要信息，确保用户的知情权。
<br/>4.服务方在进行自动续费操作时，将严格遵守相关法律法规和支付机构的规定，确保用户的支付信息安全，未经用户许可，不得将用户的支付信息用于其他目的。

<br/><br/>八、退款政策

<br/>1.一般情况下，由于自动续费服务的性质，用户支付的费用将不予退还。但在以下特殊情况下，用户可申请部分或全部退款：
<br/>1.因服务方的过错导致用户无法正常使用基础服务，且在合理时间内无法解决问题，用户可向服务方提出退款申请，服务方将根据用户的剩余服务期限和实际情况进行退款处理。
<br/>2.若用户在不知情或未经授权的情况下被开通自动续费服务，用户在发现后的 [具体时长，如 7 天] 内联系服务方并提供相关证明，服务方将核实情况并进行退款处理。
<br/>3.因服务方对服务费用的调整或服务内容的变更，用户不同意继续使用自动续费服务的，用户可在变更生效前申请终止服务并要求退款，服务方将根据用户的剩余服务期限和相关规定进行退款处理。
<br/>2.申请退款时，用户需向服务方提供详细的退款申请和必要的证明材料，服务方将在收到申请后的 [具体时长，如 15 个工作日] 内进行审核和处理，退款将原路返回至用户的支付账户。

<br/><br/>九、服务的暂停和终止

<br/>1.服务方有权在以下情况下暂停或终止用户的自动续费服务：
<br/>1.用户违反本协议或相关法律法规，服务方有权立即暂停或终止自动续费服务，并有权保留进一步追究用户法律责任的权利。
<br/>2.因不可抗力、技术故障、网络问题或其他不可预见、不可避免的因素导致服务无法正常提供，服务方有权暂停或终止自动续费服务，但将尽力采取措施减少用户的损失。
<br/>3.用户自行终止自动续费服务或终止基础服务的使用，自动续费服务将相应终止。
<br/>2.若因服务方的原因导致自动续费服务暂停或终止，服务方将根据用户的剩余服务期限和实际情况采取相应的补救措施，如延长服务期限、退还部分费用等；若因用户的原因导致服务终止，服务方将不承担任何责任，已收取的费用不予退还。

<br/><br/>十、隐私保护

<br/>1.服务方将严格遵守隐私政策，保护用户的个人信息和支付信息。关于用户信息的收集、使用、存储、保护和共享等方面，将遵循服务方的隐私政策，请用户在使用服务前仔细阅读隐私政策。
<br/>2.服务方承诺仅将用户的信息用于自动续费服务及相关服务的提供和管理，不会将用户信息泄露给未经授权的第三方，除非法律法规另有规定。

<br/><br/>十一、法律适用和争议解决

<br/>1.本协议受 [具体国家或地区] 法律的管辖。
<br/>2.因本协议的解释、履行、违约或终止等引起的任何争议，双方应首先通过友好协商解决；协商不成的，任何一方可向有管辖权的 [具体法院或仲裁机构] 提起诉讼或仲裁。

<br/><br/>十二、其他条款

<br/>1.本协议构成用户与服务方之间关于自动续费服务的完整协议，如本协议的部分条款被认定为无效或不可执行，不影响其他条款的效力。
<br/>2.本协议的更新和修改将通过服务方的官方网站、应用程序或其他合适的渠道通知用户，用户继续使用自动续费服务视为对修改后的协议的同意。


            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>